/**
 * Fehler des API-Clients: jede Nicht-2xx-Antwort und jeder Netzwerkfehler. `message` ist der
 * Server-Text (leer, wenn der Body keiner war), `code` der stabile Schlüssel des Servers
 * (null, wenn unbekannt), `status` 0 bei Netzwerkfehlern. Eigenes Modul ohne Abhängigkeiten,
 * damit Tests `api/apiClient` mocken können, ohne die Klasse zu verlieren.
 */
export class ApiClientError extends Error {
  constructor({ status, code, message, details }) {
    super(message || '');
    this.name = 'ApiClientError';
    this.status = status;
    this.code = code ?? null;
    this.details = details;
  }
}
